import { Alert, Button, Field, formatMoney, Input, Modal } from "@cafe/ui";
import { ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useApprovalStore } from "@/shared/api/approval";
import { ApiError, errorMessage, http } from "@/shared/api/client";

/** Окно «Подтверждение менеджера»: менеджер вводит свой PIN на этом устройстве → одноразовый токен (ТЗ 04 §2.1). */
export function ApprovalHost() {
  const { t } = useTranslation();
  const req = useApprovalStore((s) => s.req);
  const [pin, setPin] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setPin(""); setError(null); }, [req]);
  if (!req) return null;

  const fmt = (v: number) => (req.action === "order.discount" ? `${v}%` : formatMoney(v));
  const actionLabel = t(`approval.actions.${req.action.replace(".", "_")}` as "approval.actions.order_discount", { defaultValue: req.action });
  const submit = async () => {
    if (!/^\d{4,6}$/.test(pin)) return setError(t("approval.pinFormat"));
    setBusy(true);
    try {
      const r = await http.post<{ approvalToken: string }>("/approvals", { action: req.action, entityId: req.entityId, value: req.value, pin });
      req.resolve(r.approvalToken);
    } catch (e) {
      setPin("");
      setError(e instanceof ApiError && e.code === "INVALID_CREDENTIALS" ? t("approval.wrongPin")
        : e instanceof ApiError && e.code === "PERMISSION_DENIED" ? t("approval.noRight")
          : e instanceof ApiError && e.code === "APPROVAL_INVALID" ? t("approval.self") : errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open onOpenChange={(o) => !o && !busy && req.resolve(null)} size="sm" title={t("approval.title")}
      description={req.action === "order.void" ? t("approval.descriptionVoid")
        : t("approval.description", { action: actionLabel, value: fmt(req.value), limit: req.limit === null ? "—" : fmt(req.limit) })}
      footer={<><Button onClick={submit} loading={busy} leftIcon={<ShieldCheck />}>{t("approval.confirm")}</Button><Button variant="outline" onClick={() => req.resolve(null)} disabled={busy}>{t("common.cancel")}</Button></>}>
      <form onSubmit={(e) => { e.preventDefault(); void submit(); }} className="flex flex-col gap-3">
        <Field label={t("approval.pin")} error={error ?? undefined}>
          <Input type="password" inputMode="numeric" autoComplete="off" autoFocus maxLength={6} value={pin} onChange={(e) => { setPin(e.target.value.replace(/\D/g, "")); setError(null); }} />
        </Field>
        <Alert tone="info">{t("approval.hint")}</Alert>
      </form>
    </Modal>
  );
}
